//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../media/MediaQuery";

//css
import styled from "styled-components";
import { M, MMinus, MPlus, T } from "../../../utils/MT";

// img
import InfoSvg from "../../../assets/img/icon/info.svg";
import CloseSvg from "../../../assets/img/icon/icon_close.svg";
import SemoSvg from "../../../assets/img/icon/semo.svg";
import ArrowDownSvg from "../../../assets/img/icon/icon_arrow_down.svg";

// componet
import BasicBtn from "../../../component/button/BasicBtn";
import CheckBox from "../../../component/button/CheckBox";
import RadioBox from "../../../component/button/RadioBox";
import SelectBox from "../../../component/button/SelectBox";
import modalScroll from "../../../utils/ModalScroll";

// 임시 이미지
import Product from "../../../assets/img/picture/product_01.jpg";

// 임시데이터
import { cartDataList } from "../../../Data";
import MyPageLevelBox from "../../../component/content/MyPageLevelBox";

export default function Pay({ setErrorModal }) {
    // 프리오더 분기처리
    const [preOrder, setPreOrder] = useState(false);

    //페이지 이동
    const navigate = useNavigate();
    const PayCompletePage = () => {
        navigate(`/pay/complete`);
    };

    // 에러 팝업
    const [err, setErr] = useState(false);

    // SELECT 박스
    // 1. 쿠폰/적립금
    const [couponBoxShow, setCouponBoxShow] = useState(false);
    const [couponSelect, setCouponSelect] = useState("사용가능쿠폰 1장 / 보유 2장");
    const couponList = [
        {
            id: 0,
            coupon: "선택 안함",
            disable: false,
        },
        {
            id: 1,
            coupon: "100 원 이상 구매시 3,000원 할인",
            disable: false,
        },
        {
            id: 2,
            coupon: "1,000 원 이상 구매시 15,000원 할인",
            disable: true,
        },
    ];

    // 3.결제방법
    // 카드사 선택 옵션
    const [cardBoxShow, setCardBoxShow] = useState(false);
    const [cardSelect, setCardSelect] = useState("카드사를 선택해주세요.");
    const cardList = ["카드사를 선택해주세요.", "신한카드", "국민카드", "하나카드", "현대카드", "삼성카드", "씨티은행"];

    // 카드사 선택시 결제기간 선택
    const [payDateShow, setPayDateShow] = useState(false);

    // 카드사 일시불 선택 옵션
    const [payDateBoxShow, setPayDateBoxShow] = useState(false);
    const [payDateSelect, setPayDateSelect] = useState("일시불");
    const payDateDataList = ["일시불", "1개월", "2개월", "3개월", "4개월", "5개월", "6개월"];

    // 결제페이지 탭 리스트
    const payList = ["무통장입금", "신용/체크카드"];
    const [selectPay, setSelectPay] = useState(0);

    // 말풍선
    function BubblePop(props) {
        return (
            // <BubblePopWrap ref={props.el}>
            <BubblePopWrap leftBubble={props.leftBubble} bottomBubble={props.bottomBubble}>
                <BubbleTitle>{props.Infotext.title}</BubbleTitle>
                <CloseIcon
                    onClick={() => {
                        props.togglePop(props.Infotext.id);
                    }}
                    src={CloseSvg}
                    alt="닫기"
                />
                <BubbleListWrap>
                    {props.Infotext.textlist.map((list, index) => {
                        return <BubbleList key={index}>{list.text}</BubbleList>;
                    })}
                </BubbleListWrap>
            </BubblePopWrap>
        );
    }

    const el = useRef();

    // 문의글 토글
    const [shownPop, setShownPop] = useState(false);
    const togglePop = (id) => {
        setShownPop((prevShownPop) => ({
            ...prevShownPop,
            [id]: !prevShownPop[id],
        }));
    };

    //     const handleClickOutside = ({ target }) => {
    //         if (bubbleOpen && (!el.current || !el.current.contains(target))) setBubbleOpen(false);
    //     }

    //    useEffect(() => {
    //      window.addEventListener('click', handleClickOutside);
    //      return () => {
    //        window.removeEventListener('click', handleClickOutside);
    //      };
    //    }, []);

    // 안내 말풍선 TEXT
    const Infotext = [
        // 1. 배송정보 == 배송정보안내 말풍선
        {
            id: 0,
            title: "배송정보 안내",
            textlist: [
                {
                    text: "도서산간 지역의 경우 추후 수령 시 추가 배송비가 발생할 수 있습니다.",
                },
                {
                    text: "배송지 불분명 및 수신불가 연락처 기입으로 반송되는 왕복 택배 비용은 구매자 부담으로 정확한 주소 및 통화 가능한 연락처 필수 기입.",
                },
            ],
        },
        // 2. 쿠폰/적립금 == 포인트안내 말풍선
        {
            id: 1,
            title: "포인트 안내",
            textlist: [
                {
                    text: "30,000원 이상 결제 시 사용 가능합니다. (3,000P 이상부터 사용 가능)",
                },
                {
                    text: "포인트 적립은 최종결제금액(쿠폰, 포인트 금액 제외) 기준으로 적립되며, 상품에 따라 적립률이 상이할 수 있습니다.",
                },
            ],
        },
        // 3. 결제방법 == 신용/체크카드안내 말풍선
        {
            id: 2,
            title: "신용/체크카드안내",
            textlist: [
                {
                    text: "MAC 환경에서도 신용카드 결제가 가능합니다. (ISP 결제 제외)",
                },
                {
                    text: "금요일 오후 6시 이후부터 일요일 주문은 결제 완료 후 취소 요청 시 고객센터 > 주문취소를 이용하시면 됩니다.",
                },
            ],
        },
        // 4. 결제방법 == 무통장 입금
        {
            id: 3,
            title: "무통장입금 안내",
            textlist: [
                {
                    text: "입금기한 : 주문기준일 +3일",
                },
                {
                    text: "무통장 입금 시 사용되는 가상계좌는 주문 시마다 새로운 계좌번호(개인전용)가 부여되며 해당 주문에만 유효합니다.",
                },
            ],
        },
        // 5. 결제방법 == 에스크로
        {
            id: 4,
            title: "에스크로(결제대금예치)신청 안내",
            textlist: [
                {
                    text: "???????????",
                },
                {
                    text: "???????????",
                },
            ],
        },
    ];

    return (
        <Warp>
            <Title>ORDER</Title>
            <OrderWrap>
                {/* 결제정보 */}
                <InfoBox>
                    {/* >> 1. 배송정보 */}
                    <InfoSection>
                        <InfoTitleWrap>
                            <InfoTitle>배송정보</InfoTitle>
                            <PopWrap>
                                <InfoIcon
                                    onClick={() => {
                                        togglePop(0);
                                    }}
                                    src={InfoSvg}
                                    alt="도움 아이콘"
                                />
                                {/* 말풍선 */}
                                {shownPop[0] && <BubblePop Infotext={Infotext[0]} togglePop={togglePop} />}
                            </PopWrap>
                            <ImportantText>
                                <Important>*</Important>필수 입력항목
                            </ImportantText>
                        </InfoTitleWrap>

                        <InfoListDivWrap>
                            <InputList>
                                {/* 배송지 선택 */}
                                <InputTitle>배송지 선택</InputTitle>
                                <FlexInputWrap>
                                    <RadioBox id="basicAdr" text="기본주소" name="address" checked={true} />
                                    <RadioBox id="newAdr" text="새로입력" name="address" checked={false} />
                                </FlexInputWrap>
                            </InputList>

                            {/* 배송지명 */}
                            <InputList>
                                <InputTitle>배송지명</InputTitle>
                                <InputWrap>
                                    <TextInput type="text" placeholder="배송지명을 입력하여주세요." />
                                </InputWrap>
                            </InputList>

                            {/* 수령인 */}
                            <InputList>
                                <InputTitle>
                                    수령인<Important>*</Important>
                                </InputTitle>
                                <InputWrap>
                                    <TextInput type="text" placeholder="수령인을 입력하여주세요." required />
                                </InputWrap>
                            </InputList>

                            {/* 배송지 */}
                            <InputList>
                                <InputTitle>
                                    배송지<Important>*</Important>
                                </InputTitle>
                                <InputWrap>
                                    <InputInnerWrap>
                                        <TextInput type="text" placeholder="우편번호" readOnly />
                                        <AdrBtnWrap>
                                            <BasicBtn border={true} text="우편번호 검색" />
                                        </AdrBtnWrap>
                                    </InputInnerWrap>
                                </InputWrap>
                            </InputList>
                            <AdrInputList>
                                <InputWrap>
                                    <TextInput type="text" placeholder="주소" readOnly />
                                </InputWrap>
                            </AdrInputList>
                            <AdrInputList margin10>
                                <InputWrap>
                                    <TextInput type="text" placeholder="상세주소" required />
                                </InputWrap>
                            </AdrInputList>
                            <AdrInputList margin30>
                                <ChkBoxWrap>
                                    <CheckBox id="saveBasicAddr" text="기본배송지로 저장" withText={true} />
                                </ChkBoxWrap>
                            </AdrInputList>

                            {/* 연락처 1 */}
                            <InputList>
                                <InputTitle>
                                    연락처1<Important>*</Important>
                                </InputTitle>
                                <FlexInputWrap>
                                    <NumInput type="text" placeholder="010" />
                                    <Bar></Bar>
                                    <NumInput type="text" placeholder="0000" />
                                    <Bar></Bar>
                                    <NumInput type="text" placeholder="0000" />
                                </FlexInputWrap>
                            </InputList>

                            {/* 연락처 2 */}
                            <InputList>
                                <InputTitle>연락처2</InputTitle>
                                <FlexInputWrap>
                                    <NumInput type="text" />
                                    <Bar></Bar>
                                    <NumInput type="text" />
                                    <Bar></Bar>
                                    <NumInput type="text" />
                                </FlexInputWrap>
                            </InputList>

                            {/* 배송메세지 */}
                            <InputList>
                                <InputTitle>배송메세지</InputTitle>
                                <InputWrap>
                                    <TextInput type="text" placeholder="배송메세지를 입력하여주세요." />
                                </InputWrap>
                            </InputList>
                        </InfoListDivWrap>
                    </InfoSection>

                    <Mobile>
                        <InfoSection>
                            {/* Mobile ----- 주문상품 정보 */}
                            <ContentTitleWrap>
                                <ContentTitle>주문 상품정보</ContentTitle>
                                <ContentNum>총 1개</ContentNum>
                            </ContentTitleWrap>

                            <InfoListDivWrap>
                                <ItemListWrap>
                                    {/* 상품 리스트 */}
                                    {cartDataList.map((item, index) => {
                                        return (
                                            <ItemList key={index}>
                                                <ImgWrap>
                                                    <Img src={item.productImg} alt={item.itemName} />
                                                </ImgWrap>

                                                <ItemInfoWrap>
                                                    {/* 제품명 */}
                                                    <Name>{item.itemName}</Name>

                                                    {/* 옵션명 */}
                                                    <OptionWrap>
                                                        <Option>옵션:</Option>
                                                        <OptionText>{item.option}</OptionText>
                                                    </OptionWrap>

                                                    {/* 할인 */}
                                                    <ItemPriceWrap>
                                                        <Dis>[{item.percent}]</Dis>
                                                        <OriginPrice>{item.price}</OriginPrice>
                                                        <ItemWon>원</ItemWon>
                                                    </ItemPriceWrap>
                                                </ItemInfoWrap>
                                            </ItemList>
                                        );
                                    })}
                                </ItemListWrap>
                            </InfoListDivWrap>
                        </InfoSection>
                    </Mobile>

                    {/* 프리오더일땐 쿠폰/적립금 안보이게 분기처리 부탁드립니다! */}
                    {!preOrder && (
                        //  {/* >> 2. 쿠폰/적립금 */}
                        <InfoSection>
                            <InfoTitleWrap>
                                <InfoTitle>쿠폰/적립금</InfoTitle>
                                <PopWrap>
                                    <InfoIcon
                                        onClick={() => {
                                            togglePop(1);
                                        }}
                                        src={InfoSvg}
                                        alt="도움 아이콘"
                                    />
                                    {/* 말풍선 */}
                                    {shownPop[1] && <BubblePop Infotext={Infotext[1]} togglePop={togglePop} />}
                                </PopWrap>
                            </InfoTitleWrap>

                            <InfoListDivWrap>
                                {/* 쿠폰 선택 */}
                                {/* 사용불가 쿠폰 */}
                                <InputList>
                                    <InputTitle>쿠폰</InputTitle>
                                    <InputWrap>
                                        <OptionListBigWrap borderActive={couponBoxShow ? true : null}>
                                            <SelectedButton
                                                active={couponBoxShow ? true : null}
                                                onClick={() => {
                                                    setCouponBoxShow(!couponBoxShow);
                                                }}
                                            >
                                                {couponSelect}
                                            </SelectedButton>
                                            {couponBoxShow ? (
                                                <SelectListBox borderActive={couponBoxShow ? true : null}>
                                                    {couponList.map((option, index) => {
                                                        return (
                                                            <OptionBtn key={"option" + index}>
                                                                <ChkInput
                                                                    onClick={() => {
                                                                        setCouponSelect(option.coupon);
                                                                    }}
                                                                    type="radio"
                                                                    id={"coupon" + option.id}
                                                                    name="selectCoupon"
                                                                    disabled={option.disable}
                                                                />
                                                                <ChkLabel htmlFor={"coupon" + option.id}>
                                                                    <BasicChkImg className="chkImg"></BasicChkImg>
                                                                    <ChkText>{option.coupon}</ChkText>
                                                                </ChkLabel>
                                                            </OptionBtn>
                                                        );
                                                    })}
                                                </SelectListBox>
                                            ) : null}
                                        </OptionListBigWrap>
                                    </InputWrap>
                                </InputList>

                                {/* 적립금 */}
                                <InputList margin10>
                                    <InputTitle>적립금</InputTitle>
                                    <FlexInputWrap>
                                        <TextInput type="text" placeholder="0" />
                                        <PointBtnWrap>
                                            <BasicBtn border={true} text="모두 사용" />
                                        </PointBtnWrap>
                                    </FlexInputWrap>
                                </InputList>
                                <SmallText>
                                    보유적립금 <Point>5,000P</Point>
                                </SmallText>
                            </InfoListDivWrap>
                        </InfoSection>
                    )}

                    {/* >> 3.결제방법 */}
                    <InfoSection>
                        <InfoTitleWrap>
                            <InfoTitle>결제방법</InfoTitle>
                        </InfoTitleWrap>

                        <InfoListDivWrap>
                            {/* 무통장입금 == 0 // 신용카드 == 1 */}
                            {selectPay == 0 ? (
                                <>
                                    <GrayInfoText
                                        onClick={() => {
                                            togglePop(3);
                                        }}
                                    >
                                        무통장입금 안내
                                    </GrayInfoText>
                                    {/* 말풍선 */}
                                    {shownPop[3] && <BubblePop leftBubble={true} Infotext={Infotext[3]} togglePop={togglePop} />}
                                </>
                            ) : (
                                <>
                                    <GrayInfoText
                                        onClick={() => {
                                            togglePop(2);
                                        }}
                                    >
                                        신용/체크카드 안내
                                    </GrayInfoText>
                                    {/* 말풍선 */}
                                    {shownPop[2] && <BubblePop leftBubble={true} Infotext={Infotext[2]} togglePop={togglePop} />}
                                </>
                            )}
                            {/* 결제방법 선택 */}
                            <InputList>
                                <PayBtnWrap>
                                    {payList.map((item, index) => {
                                        return (
                                            <BasicBtn
                                                key={"payList" + index}
                                                text={item}
                                                gray={selectPay !== index ? true : ""}
                                                black={selectPay !== index ? true : ""}
                                                onClick={() => setSelectPay(index)}
                                            />
                                        );
                                    })}
                                </PayBtnWrap>
                            </InputList>
                            {selectPay == 0 ? (
                                <Banking>
                                    <FlexInputWrap>
                                        <ChkInput type="checkbox" id="escrow" />
                                        <ChkLabel htmlFor="escrow">
                                            <ChkImg className="chkImg"></ChkImg>
                                            <ChkText>에스크로(결제대금예치)신청</ChkText>
                                        </ChkLabel>
                                        <PopWrap>
                                            <InfoIcon
                                                onClick={() => {
                                                    togglePop(4);
                                                }}
                                                src={InfoSvg}
                                                alt="도움 아이콘"
                                            />
                                            {/* 말풍선 */}
                                            {shownPop[4] && <BubblePop bottomBubble={true} Infotext={Infotext[4]} togglePop={togglePop} />}
                                        </PopWrap>
                                    </FlexInputWrap>
                                    {/* <CheckBox id="escrow" withText={true} text="에스크로(결제대금예치)신청"/> */}
                                </Banking>
                            ) : (
                                <>
                                    <InputList>
                                        <SelectBox
                                            gray={true}
                                            optionBoxShow={cardBoxShow}
                                            setOptionBoxShow={setCardBoxShow}
                                            optionSelect={cardSelect}
                                            setOptionSelect={setCardSelect}
                                            optionList={cardList}
                                            haveSecond={true}
                                            setSecondBoxShow={setPayDateShow}
                                            // onClick={ () => { setPayDateSelect(payDateSelect(1)) }}
                                        />
                                    </InputList>
                                    {payDateShow ? (
                                        <InputList>
                                            <SelectBox
                                                gray={true}
                                                optionBoxShow={payDateBoxShow}
                                                setOptionBoxShow={setPayDateBoxShow}
                                                optionSelect={payDateSelect}
                                                setOptionSelect={setPayDateSelect}
                                                optionList={payDateDataList}
                                            />
                                        </InputList>
                                    ) : null}
                                </>
                            )}
                        </InfoListDivWrap>
                    </InfoSection>

                    {/* >> 4.개인정보이용동의 */}
                    <InfoSection>
                        <InfoTitleWrap>
                            <InfoTitle>개인정보이용동의</InfoTitle>
                        </InfoTitleWrap>

                        <InfoListWrap>
                            <InputList>
                                <InputWrap>
                                    <ChkInput type="checkbox" id="Privacy" />
                                    <ChkLabel htmlFor="Privacy">
                                        <ChkText>이용약관 및 개인정보 제3자 제공사항에 대해 확인하였으며 결제에 동의합니다.</ChkText>
                                        <ChkImg className="chkImg" marginLeft></ChkImg>
                                    </ChkLabel>
                                </InputWrap>
                            </InputList>
                        </InfoListWrap>
                    </InfoSection>
                </InfoBox>

                {/* 구매항목 */}
                <ContentWrap>
                    <ContentBox>
                        <InnerBox>
                            <PC>
                                {/* PC ----- 주문상품 정보 */}
                                <ContentTitleWrap>
                                    <ContentTitle>주문 상품정보</ContentTitle>
                                    <ContentNum>총 1개</ContentNum>
                                </ContentTitleWrap>

                                <ItemListWrap>
                                    {/* 상품 리스트 */}
                                    {cartDataList.map((item, index) => {
                                        return (
                                            <ItemList key={index}>
                                                <ImgWrap>
                                                    <Img src={item.productImg} alt={item.itemName} />
                                                </ImgWrap>

                                                <ItemInfoWrap>
                                                    {/* 제품명 */}
                                                    <Name>{item.itemName}</Name>

                                                    {/* 옵션명 */}
                                                    <OptionWrap>
                                                        <Option>옵션:</Option>
                                                        <OptionText>{item.option}</OptionText>
                                                    </OptionWrap>

                                                    {/* 할인 */}
                                                    <ItemPriceWrap>
                                                        <Dis>[{item.percent}]</Dis>
                                                        <OriginPrice>{item.price}</OriginPrice>
                                                        <ItemWon>원</ItemWon>
                                                    </ItemPriceWrap>
                                                </ItemInfoWrap>
                                            </ItemList>
                                        );
                                    })}
                                </ItemListWrap>
                            </PC>

                            {/* 결제금액 */}
                            <Mobile>
                                <InfoTitleWrap>
                                    <InfoTitle>결제금액</InfoTitle>
                                </InfoTitleWrap>
                            </Mobile>

                            <PriceListWrap>
                                <PriceList>
                                    <PriceTitle>총 상품 금액</PriceTitle>
                                    <PriceWrap>
                                        <Price>9,900,000</Price>
                                        <Won>원</Won>
                                    </PriceWrap>
                                </PriceList>
                                <PriceList>
                                    <PriceTitle>배송비</PriceTitle>
                                    <PriceWrap>
                                        <Price>3,000</Price>
                                        <Won>원</Won>
                                    </PriceWrap>
                                </PriceList>
                                <PriceList>
                                    <PriceTitle>적립금 사용</PriceTitle>
                                    <PriceWrap>
                                        <Price>- 5,000</Price>
                                        <Won>원</Won>
                                    </PriceWrap>
                                </PriceList>
                                <PriceList>
                                    <PriceTitle>쿠폰 사용</PriceTitle>
                                    <PriceWrap>
                                        <Price>- 5,000</Price>
                                        <Won>원</Won>
                                    </PriceWrap>
                                </PriceList>
                                <BigPriceList>
                                    <PriceTitle bold>총 상품 금액</PriceTitle>
                                    <BasePriceWrap>
                                        <Price orange>9,895,000</Price>
                                        <Won bold>원</Won>
                                    </BasePriceWrap>
                                </BigPriceList>
                                <PriceList>
                                    <PriceTitle gray>예정 적립금</PriceTitle>
                                    <PriceWrap>
                                        <Price gray>3,000</Price>
                                        <Won gray>원</Won>
                                    </PriceWrap>
                                </PriceList>
                            </PriceListWrap>
                        </InnerBox>

                        {/* PC용 CHECKOUT 버튼 */}
                        <PC>
                            <SumbitBtn>
                                {/* 상황에따라 각각의 팝업 텍스트 노출해주세요! ( PayPage 에 있습니다! )
                                1. 수령인 이름 누락
                                2. 배송지
                                3. 수령인 연락처
                                4. 주문 상품정보에 대해 동의
                                5. 결제수단
                            */}
                                {err ? (
                                    <BasicBtn
                                        onClick={() => {
                                            setErrorModal(true);
                                            modalScroll.modalOpen();
                                        }}
                                        text="CHECK OUT"
                                    />
                                ) : (
                                    <BasicBtn
                                        onClick={() => {
                                            PayCompletePage();
                                        }}
                                        text="CHECK OUT"
                                    />
                                )}
                            </SumbitBtn>
                        </PC>
                    </ContentBox>
                </ContentWrap>
            </OrderWrap>

            {/* MOBILE용 CHECKOUT 버튼 */}
            <Mobile>
                <SumbitBtn>
                    {/* 상황에따라 각각의 팝업 텍스트 노출해주세요! ( PayPage 에 있습니다! )
                                1. 수령인 이름 누락
                                2. 배송지
                                3. 수령인 연락처
                                4. 주문 상품정보에 대해 동의
                                5. 결제수단
                            */}
                    {err ? (
                        <BasicBtn
                            onClick={() => {
                                setErrorModal(true);
                                modalScroll.modalOpen();
                            }}
                            text="CHECK OUT"
                        />
                    ) : (
                        <BasicBtn
                            onClick={() => {
                                PayCompletePage();
                            }}
                            text="CHECK OUT"
                        />
                    )}
                </SumbitBtn>
            </Mobile>
        </Warp>
    );
}

const Warp = styled.div`
    position: relative;
    width: calc(100vw * (1060 / 1920));
    margin: 0 auto;

    padding-top: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));

        padding-top: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        padding: ${M(30)} 0;
    }
`;
const Title = styled.h3`
    font-family: "Pop-EL";
    font-size: calc(100vw * (50 / 1920));

    margin-bottom: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (50 / 1300));

        margin-bottom: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-family: "Pop-R ";
        font-size: ${M(20)};
        margin-bottom: ${M(36)};
    }
`;

const OrderWrap = styled.div`
    position: relative;
    width: 100%;

    display: flex;

    margin-bottom: calc(100vw * (240 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (240 / 1300));
    }

    @media screen and (max-width: 900px) {
        display: block;
        margin-bottom: ${M(80)};
    }
`;

const InfoBox = styled.div`
    flex-shrink: 0;
    width: calc(100vw * (510 / 1920));
    margin-right: calc(100vw * (40 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (510 / 1300));
        margin-right: calc(100vw * (40 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        margin-right: 0;
    }
`;

const InfoSection = styled.section`
    &:not(:last-child) {
        margin-bottom: calc(100vw * (40 / 1920));
        border-bottom: 1px solid;
    }

    @media screen and (max-width: 1300px) {
        &:not(:last-child) {
            margin-bottom: calc(100vw * (40 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:not(:last-child) {
            margin-bottom: ${M(20)};

            border-bottom: none;
        }
    }
`;

const InfoTitleWrap = styled.h3`
    display: flex;
    align-items: center;
    padding-bottom: calc(100vw * (20 / 1920));

    border-bottom: 1px solid;

    @media screen and (max-width: 1300px) {
        padding-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-bottom: ${M(20)};
    }
`;

const InfoTitle = styled.span`
    font-size: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(18)};
    }
`;

const InfoIcon = styled.img`
    flex-shrink: 0;
    display: inline-block;
    width: calc(100vw * (20 / 1920));
    height: calc(100vw * (20 / 1920));

    margin-left: calc(100vw * (5 / 1920));

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (20 / 1300));
        height: calc(100vw * (20 / 1300));

        margin-left: calc(100vw * (5 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(20)};
        height: ${M(20)};

        margin-left: ${M(5)};
    }
`;

const ImportantText = styled.p`
    display: flex;

    font-family: "Noto-R";
    font-size: calc(100vw * (14 / 1920));

    margin-left: auto;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;

const Important = styled.span`
    font-size: calc(100vw * (14 / 1920));
    color: var(--main-color);

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;

const InfoListWrap = styled.div`
    position: relative;
    padding: calc(100vw * (20 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        padding: ${M(25)} 0 ${M(20)};
    }
`;

const InfoListDivWrap = styled.div`
    position: relative;
    padding: calc(100vw * (20 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        padding: ${M(25)} 0 ${M(20)};
    }
`;

const InputList = styled.div`
    display: flex;
    align-items: center;

    margin-bottom: calc(100vw * (20 / 1920));

    ${({ margin10 }) => {
        return (
            margin10 &&
            `
                margin-bottom: calc(100vw * (10/ 1920));
            `
        );
    }}

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (20 / 1300));

        ${({ margin10 }) => {
            return (
                margin10 &&
                `
                    margin-bottom: calc(100vw * (10/ 1300));
                `
            );
        }}
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(15)};

        ${({ margin10 }) => {
            return (
                margin10 &&
                `
                    margin-bottom:  ${M(10)};
                `
            );
        }}
        ${({ margin30 }) => {
            return (
                margin30 &&
                `
                    margin-bottom:  ${M(30)};
                `
            );
        }}
    }
`;

const InputTitle = styled.h4`
    flex-shrink: 0;
    width: calc(100vw * (110 / 1920));
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (110 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(78)};
        font-size: ${M(14)};
    }
`;

const InputWrap = styled.div`
    flex: 1;
`;

const OptionListBigWrap = styled.div`
    position: relative;
    width: 100%;

    border: 1px solid transparent;
    border-radius: 5px;
    background: #fafafa;

    ${({ borderActive }) => {
        return (
            borderActive &&
            `
                border-color: var(--main-color);
                border-bottom-color: transparent;
                border-radius: 5px 5px 0 0;
            `
        );
    }}
`;

const SelectedButton = styled.p`
    position: relative;
    width: 100%;

    font-size: calc(100vw * (15 / 1920));
    padding: calc(100vw * (12 / 1920)) calc(100vw * (15 / 1920));

    cursor: pointer;

    &:after {
        position: absolute;
        top: 50%;
        right: calc(100vw * (15 / 1920));
        content: "";
        width: calc(100vw * (10 / 1920));
        height: calc(100vw * (6 / 1920));

        background: url(${ArrowDownSvg}) no-repeat center center / contain;
        transform: translateY(-50%);
        filter: invert(59%) sepia(3%) saturate(0%) hue-rotate(26deg) brightness(97%) contrast(87%);
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
        padding: calc(100vw * (12 / 1300)) calc(100vw * (15 / 1300));

        &:after {
            right: calc(100vw * (15 / 1300));
            width: calc(100vw * (10 / 1300));
            height: calc(100vw * (6 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        padding: ${M(12)} ${M(15)};

        &:after {
            right: ${M(20)};
            width: ${M(10)};
            height: ${M(6)};
        }
    }

    ${({ active }) => {
        return (
            active &&
            `
            color: var(--main-color);

            &:after{
                transform: translateY(-50%) rotate(180deg);
            }
        `
        );
    }}
`;
const SelectListBox = styled.ul`
    position: absolute;
    top: 100%;
    left: -1px;

    width: 100%;
    max-height: calc(100vw * (280 / 1920));
    background: #fafafa;

    z-index: 5;
    overflow-y: auto;

    @media screen and (max-width: 1300px) {
        max-height: calc(100vw * (280 / 1300));
    }

    @media screen and (max-width: 900px) {
        max-height: ${M(250)};
    }

    ${({ borderActive }) => {
        return (
            borderActive &&
            `
                border: 1px solid var(--main-color);
                border-top: none;
                border-radius: 0 0 5px 5px;
                box-sizing: content-box;
            `
        );
    }}
`;

const OptionBtn = styled.li`
    font-family: "Pop-M";
    font-size: calc(100vw * (15 / 1920));
    padding: calc(100vw * (12 / 1920)) calc(100vw * (15 / 1920));

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
        padding: calc(100vw * (12 / 1300)) calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        padding: ${M(12)} ${M(15)};
    }
`;

const TextInput = styled.input`
    flex: 1;

    width: 100%;
    font-size: calc(100vw * (15 / 1920));

    padding: calc(100vw * (12 / 1920)) calc(100vw * (15 / 1920));
    border-radius: 4px;
    background: #fafafa;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        padding: calc(100vw * (12 / 1300)) calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        padding: ${M(12)} ${M(15)};
    }
`;

const InputInnerWrap = styled.div`
    display: flex;
    align-items: center;

    &:not(:first-child) {
        margin-top: calc(100vw * (20 / 1920));
    }

    @media screen and (max-width: 1300px) {
        &:not(:first-child) {
            margin-top: calc(100vw * (20 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:not(:first-child) {
            margin-top: ${M(15)};
        }
    }
`;

const AdrBtnWrap = styled.div`
    flex-shrink: 0;

    width: calc(100vw * (165 / 1920));
    margin-left: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (165 / 1300));
        margin-left: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(130)};
        margin-left: ${M(10)};

        & > p {
            padding: ${M(11)} 0;
            font-size: ${M(14)};
        }
    }
`;

const AdrInputList = styled(InputList)`
    width: 100%;
    padding-left: calc(100vw * (110 / 1920));

    @media screen and (max-width: 1300px) {
        padding-left: calc(100vw * (110 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-left: 0;
    }
`;

const ChkBoxWrap = styled.div`
    margin-top: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(5)};
    }
`;

// 연락처
const FlexInputWrap = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
`;

const Bar = styled.span`
    width: calc(100vw * (8 / 1920));
    height: 1px;

    background: #ddd;

    margin: 0 calc(100vw * (6 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (8 / 1300));

        margin: 0 calc(100vw * (6 / 1300));
    }

    @media screen and (max-width: 900px) {
        display: none;
    }
`;

const NumInput = styled(TextInput)`
    flex: auto;
    flex-shrink: 0;
    width: calc(100vw * (110 / 1920));

    text-align: center;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (110 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(96)};

        &:not(:first-child) {
            margin-left: ${M(6)};
        }
    }
`;

const PointBtnWrap = styled.div`
    flex-shrink: 0;
    width: calc(100vw * (90 / 1920));

    margin-left: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (90 / 1300));

        margin-left: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(90)};

        margin-left: ${M(10)};

        & > p {
            padding: ${M(11)} 0;
            font-size: ${M(14)};
        }
    }
`;

const SmallText = styled.p`
    display: flex;

    font-family: "Noto-R";
    font-size: calc(100vw * (15 / 1920));

    padding-left: calc(100vw * (110 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        padding-left: calc(100vw * (110 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        padding-left: ${M(78)};
    }
`;

const Point = styled.span`
    font-family: "Noto-M";
    color: var(--main-color);
    margin-left: calc(100vw * (5 / 1920));

    max-width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media screen and (max-width: 1300px) {
        margin-left: calc(100vw * (5 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-left: ${M(5)};
    }
`;

const GrayInfoText = styled.p`
    font-size: calc(100vw * (15 / 1920));
    color: #aaa;
    text-decoration: underline;
    text-align: right;

    margin-bottom: calc(100vw * (20 / 1920));

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-bottom: ${M(20)};
    }
`;

const PayBtnWrap = styled.div`
    display: flex;

    & p {
        flex-shrink: 0;
        width: calc(100vw * (160 / 1920));
    }

    & p:not(:first-child) {
        margin-left: calc(100vw * (15 / 1920));
    }

    @media screen and (max-width: 1300px) {
        & p {
            width: calc(100vw * (160 / 1300));
        }

        & p:not(:first-child) {
            margin-left: calc(100vw * (15 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        & p {
            width: ${M(180)};
        }

        & p:not(:first-child) {
            margin-left: ${M(18)};
        }
    }
`;

const Banking = styled.div``;

const ChkInput = styled.input`
    display: none;

    /* 체크되었을때 */
    &:checked + label .chkImg {
        background: var(--main-color);
    }

    &:checked + label .chkImg:after {
        height: calc(100vw * (7 / 1920));
    }

    &:checked + label .chkImg:before {
        height: calc(100vw * (11 / 1920));
    }

    /* disabled */
    &:disabled + label {
        cursor: default;
    }
    &:disabled + label .chkImg {
        border-color: #ddd;
    }

    &:disabled + label span:not(.chkImg) {
        color: #ddd;
    }

    @media screen and (max-width: 1300px) {
        &:checked + label .chkImg:after {
            height: calc(100vw * (7 / 1300));
        }

        &:checked + label .chkImg:before {
            height: calc(100vw * (11 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:checked + label .chkImg:after {
            height: ${M(7)};
        }

        &:checked + label .chkImg:before {
            height: ${M(11)};
        }
    }
`;

const ChkLabel = styled.label`
    display: flex;
    align-items: center;
`;

const ChkText = styled.span`
    font-size: calc(100vw * (14 / 1920));
    color: #222222;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;

const BasicChkImg = styled.span`
    flex-shrink: 0;
    position: relative;
    display: inline-block;
    width: calc(100vw * (20 / 1920));
    height: calc(100vw * (20 / 1920));

    margin-right: calc(100vw * (10 / 1920));

    border-radius: 4px;
    border: 1px solid var(--main-color);
    background-color: #fff;

    &:after,
    &:before {
        position: absolute;
        content: "";

        width: calc(100vw * (3 / 1920));
        height: 0;

        background-color: #fff;
        transform-origin: left top;
    }

    &:after {
        top: 45%;
        left: 12%;

        transform: rotate(-45deg);
        border-radius: 4px 4px 0 0;
        transition: height 0.2s ease;
    }
    &:before {
        top: 76%;
        left: 44%;

        transform: rotate(-135deg);
        border-radius: 4px;
        transition: height 0.2s ease 0.2s;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (20 / 1300));
        height: calc(100vw * (20 / 1300));

        margin-right: calc(100vw * (10 / 1300));

        &:after,
        &:before {
            width: calc(100vw * (3 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(20)};
        height: ${M(20)};

        margin-right: ${M(5)};

        &:after,
        &:before {
            width: ${M(2)};
        }
    }
`;

const ChkImg = styled(BasicChkImg)`
    flex-shrink: 0;
    margin-left: auto;

    ${({ marginLeft }) => {
        return (
            marginLeft &&
            `
                margin-right: 0;
                margin-left: calc(100vw * (40 / 1920));
            `
        );
    }}

    @media screen and (max-width: 1300px) {
        ${({ marginLeft }) => {
            return (
                marginLeft &&
                `
                    margin-left: calc(100vw * (40 / 1300));
                `
            );
        }}
    }

    @media screen and (max-width: 900px) {
        ${({ marginLeft }) => {
            return (
                marginLeft &&
                `
                    margin-left: ${M(20)};
                `
            );
        }}
    }
`;

const ContentWrap = styled.div`
    width: calc(100vw * (510 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (510 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
    }
`;

const ContentBox = styled.section`
    position: sticky;
    top: calc(100vw * (180 / 1920));

    @media screen and (max-width: 1300px) {
        top: calc(100vw * (180 / 1300));
    }

    @media screen and (max-width: 900px) {
        position: static;
        top: 0;
    }
`;

const InnerBox = styled.div`
    border: 1px solid #dddddd;
    border-radius: 4px;

    padding: calc(100vw * (35 / 1920)) calc(100vw * (50 / 1920)) calc(100vw * (30 / 1920)) calc(100vw * (40 / 1920));
    margin-bottom: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (35 / 1300)) calc(100vw * (50 / 1300)) calc(100vw * (30 / 1300)) calc(100vw * (40 / 1300));
        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        border: none;

        padding: 0;
        margin-bottom: 0;
    }
`;

const ContentTitleWrap = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    margin-bottom: calc(100vw * (35 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (35 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(20)};
        padding-bottom: ${M(20)};
        border-bottom: 1px solid;
    }
`;

const ContentTitle = styled.h3`
    flex-shrink: 0;
    max-width: 30%;
    font-size: calc(100vw * (20 / 1920));

    margin-right: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));

        margin-right: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        max-width: 50%;

        font-size: ${M(20)};
        margin-right: ${M(10)};
    }
`;

const ContentNum = styled.p`
    flex-shrink: 0;
    min-width: calc(100vw * (70 / 1920));

    font-family: "Noto-B";
    font-size: calc(100vw * (12 / 1920));
    text-align: center;

    border: 1px solid var(--main-color);
    border-radius: 50px;
    color: var(--main-color);

    padding: calc(100vw * (5 / 1920)) calc(100vw * (19 / 1920));

    @media screen and (max-width: 1300px) {
        min-width: calc(100vw * (70 / 1300));

        font-size: calc(100vw * (12 / 1300));

        padding: calc(100vw * (5 / 1300)) calc(100vw * (19 / 1300));
    }

    @media screen and (max-width: 900px) {
        min-width: ${M(70)};

        font-size: ${M(12)};
        padding: ${M(5)} ${M(19)};
    }
`;

const ItemListWrap = styled.ul`
    max-height: calc(100vw * (350 / 1920));
    overflow-y: auto;

    border-bottom: 1px solid #ddd;

    @media screen and (max-width: 1300px) {
        max-height: calc(100vw * (350 / 1300));
    }

    @media screen and (max-width: 900px) {
        max-height: ${M(300)};

        border-bottom: none;
    }
`;

const ItemList = styled.li`
    display: flex;

    margin-bottom: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        max-height: ${M(300)};
    }
`;

const ImgWrap = styled.div`
    flex-shrink: 0;
    width: calc(100vw * (165 / 1920));
    height: calc(100vw * (165 / 1920));

    border-radius: 4px;
    overflow: hidden;

    border: 1px solid #ddd;

    margin-right: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (165 / 1300));
        height: calc(100vw * (165 / 1300));
        margin-right: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(100)};
        height: ${M(100)};
        margin-right: ${M(20)};
    }
`;

const Img = styled.img`
    width: 100%;
    height: 100%;

    object-fit: cover;
`;

const ItemInfoWrap = styled.div`
    width: calc(100% - 100vw * (180 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100% - 100vw * (180 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${MMinus(120)};
    }
`;

const Name = styled.p`
    font-family: "Pop-EB";
    font-size: calc(100vw * (14 / 1920));

    margin-bottom: calc(100vw * (4 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));

        margin-bottom: calc(100vw * (4 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-bottom: ${M(5)};
    }
`;

const OptionWrap = styled.p`
    display: flex;

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(10)};
    }
`;

const Option = styled.span`
    flex-shrink: 0;
    max-width: calc(100vw * (30 / 1920));
    font-size: calc(100vw * (13 / 1920));
    color: #aaa;

    margin-right: calc(100vw * (3 / 1920));

    @media screen and (max-width: 1300px) {
        max-width: calc(100vw * (30 / 1300));
        font-size: calc(100vw * (13 / 1300));

        margin-right: calc(100vw * (3 / 1300));
    }

    @media screen and (max-width: 900px) {
        max-width: ${M(30)};
        font-size: ${M(13)};

        margin-right: ${M(10)};
    }
`;

const OptionText = styled.span`
    font-family: "Pop-M";
    font-size: calc(100vw * (13 / 1920));
    color: #aaa;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;

const ItemPriceWrap = styled.div`
    /* display: flex;
    align-items: center;
    flex-wrap: wrap; */

    color: var(--main-color);

    & span {
        word-break: break-all;
    }
`;

const Dis = styled.span`
    font-family: "Pop-SB";
    font-size: calc(100vw * (13 / 1920));
    color: var(--main-color);

    margin-right: calc(100vw * (5 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
        margin-right: calc(100vw * (5 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
        margin-right: ${M(5)};
    }
`;

const OriginPrice = styled.span`
    font-size: calc(100vw * (15 / 1920));

    color: var(--main-color);
    margin-right: calc(100vw * (2 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        margin-right: calc(100vw * (2 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-right: ${M(2)};
    }
`;

const ItemWon = styled.span`
    font-family: "Noto-R";
    font-size: calc(100vw * (13 / 1920));

    color: var(--main-color);

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;

const PriceListWrap = styled.ul`
    padding-top: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        padding-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding: ${M(25)} 0 ${M(20)};
    }
`;

const PriceList = styled.li`
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:not(:first-child) {
        margin-top: calc(100vw * (20 / 1920));
    }

    @media screen and (max-width: 1300px) {
        &:not(:first-child) {
            margin-top: calc(100vw * (20 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:not(:first-child) {
            margin-top: ${M(10)};
        }
    }
`;

const BigPriceList = styled(PriceList)`
    border-bottom: 1px solid #ddd;
    padding-bottom: calc(100vw * (29 / 1920));

    @media screen and (max-width: 1300px) {
        padding-bottom: calc(100vw * (29 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-bottom: ${M(20)};
    }
`;

const PriceTitle = styled.div`
    flex-shrink: 0;
    max-width: 20%;
    font-size: calc(100vw * (15 / 1920));

    margin-right: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        margin-right: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        margin-right: ${M(15)};
    }

    ${({ gray }) => {
        return (
            gray &&
            `
            color: #AAA;
        `
        );
    }}

    ${({ bold }) => {
        return (
            bold &&
            `
            font-family: "Noto-B";
        `
        );
    }}
`;

const PriceWrap = styled.div`
    display: flex;
    align-items: center;
`;

const BasePriceWrap = styled(PriceWrap)`
    align-items: baseline;
`;

const Price = styled.span`
    font-size: calc(100vw * (15 / 1920));
    margin-right: calc(100vw * (2 / 1920));
    word-break: break-all;

    ${({ gray }) => {
        return (
            gray &&
            `
            color: #8C8C8C;
        `
        );
    }}

    ${({ orange }) => {
        return (
            orange &&
            `
            font-family: "Noto-B";
            font-size: calc(100vw * (25/ 1920));
            color: var(--main-color);
        `
        );
    }}

@media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
        margin-right: calc(100vw * (2 / 1300));

        ${({ orange }) => {
            return (
                orange &&
                `
                    font-size: calc(100vw * (25/ 1300));
                `
            );
        }}
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-right: ${M(2)};

        ${({ orange }) => {
            return (
                orange &&
                `
                    font-size: ${M(18)};
                `
            );
        }}
    }
`;

const Won = styled.span`
    font-size: calc(100vw * (15 / 1920));
    margin-left: calc(100vw * (2 / 1920));

    ${({ bold }) => {
        return (
            bold &&
            `
            font-size: calc(100vw * (20/ 1920));
        `
        );
    }}

    ${({ gray }) => {
        return (
            gray &&
            `
            color: #8C8C8C;
        `
        );
    }}

@media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
        margin-left: calc(100vw * (2 / 1300));

        ${({ bold }) => {
            return (
                bold &&
                `
            font-size: calc(100vw * (20/ 1300));
        `
            );
        }}
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-left: ${M(2)};

        ${({ bold }) => {
            return (
                bold &&
                `
                    font-size: ${M(18)};
                `
            );
        }}
    }
`;

const SumbitBtn = styled.div`
    & p {
        padding: calc(100vw * (13 / 1920)) 0;
        font-family: "Pop-SB";
        font-size: calc(100vw * (20 / 1920));
    }

    @media screen and (max-width: 1300px) {
        & p {
            padding: calc(100vw * (13 / 1300)) 0;
            font-size: calc(100vw * (20 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        position: sticky;
        bottom: ${M(13)};
        left: 0;

        width: ${M(378)};

        transform: none;

        z-index: 4;

        & p {
            padding: ${M(15)} 0;
            font-size: ${M(18)};
        }
    }
`;

const BubblePopWrap = styled.div`
    position: absolute;
    top: calc(100vw * (-8 / 1920));
    left: calc(100% + 100vw * (25 / 1920));

    width: calc(100vw * (260 / 1920));

    background: #fff;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.16);

    padding: calc(100vw * (15 / 1920));

    z-index: 7;

    &:after {
        position: absolute;
        top: calc(100vw * (13 / 1920));
        right: calc(100% - 100vw * (3 / 1920));
        content: "";

        width: calc(100vw * (15 / 1920));
        height: calc(100vw * (12 / 1920));

        background: url(${SemoSvg}) no-repeat center center / contain;

        filter: drop-shadow(-3px 0px 2px rgba(0, 0, 0, 0.16));

        z-index: 0;
    }

    @media screen and (max-width: 1300px) {
        top: calc(100vw * (-8 / 1300));
        left: calc(100% + 100vw * (25 / 1300));

        width: calc(100vw * (260 / 1300));

        padding: calc(100vw * (15 / 1300));

        &:after {
            top: calc(100vw * (13 / 1300));
            right: calc(100% - 100vw * (3 / 1300));

            width: calc(100vw * (15 / 1300));
            height: calc(100vw * (12 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        top: ${M(-8)};
        left: ${MPlus(25)};

        width: ${M(250)};

        padding: ${M(15)};

        &:after {
            top: ${M(13)};
            right: ${MMinus(3)};

            width: ${M(15)};
            height: ${M(12)};
        }

        ${({ leftBubble }) => {
            return (
                leftBubble &&
                `
                    top: ${M(15)};
                    left: 0;


                    &:after {
                        right: unset;
                        left: ${MMinus(3)};


                        transform: rotate(180deg);
                    }

                `
            );
        }}

        ${({ bottomBubble }) => {
            return (
                bottomBubble &&
                `
                    top: ${M(30)};
                    left: 50%;

                    transform: translateX(-50%);

                    &:after {
                        top: 0;
                        right: unset;
                        left: 50%;

                        transform: rotate(90deg) translate(-50%, 50%);
  
                    }

                `
            );
        }}
    }
`;

const BubbleTitle = styled.h5`
    font-size: calc(100vw * (15 / 1920));

    margin-bottom: calc(100vw * (14 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        margin-bottom: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};

        margin-bottom: ${M(15)};
    }
`;

const CloseIcon = styled.img`
    position: absolute;
    top: calc(100vw * (20 / 1920));
    right: calc(100vw * (15 / 1920));

    width: calc(100vw * (11 / 1920));
    height: calc(100vw * (11 / 1920));

    cursor: pointer;
    z-index: 2;

    @media screen and (max-width: 1300px) {
        top: calc(100vw * (20 / 1300));
        right: calc(100vw * (15 / 1300));

        width: calc(100vw * (11 / 1300));
        height: calc(100vw * (11 / 1300));
    }

    @media screen and (max-width: 900px) {
        top: ${M(20)};
        right: ${M(15)};

        width: ${M(11)};
        height: ${M(11)};
    }
`;

const BubbleListWrap = styled.ul``;

const BubbleList = styled.li`
    position: relative;
    font-family: "Noto-R";
    font-size: calc(100vw * (13 / 1920));
    line-height: 1.46;

    padding-left: calc(100vw * (12 / 1920));
    word-break: keep-all;

    &:not(:last-child) {
        margin-top: calc(100vw * (15 / 1920));
    }

    &:after {
        position: absolute;
        top: calc(100vw * (7 / 1920));
        left: 0;

        content: "";
        width: calc(100vw * (4 / 1920));
        height: calc(100vw * (4 / 1920));
        background: var(--main-color);

        border-radius: 50%;
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));

        padding-left: calc(100vw * (12 / 1300));

        &:not(:last-child) {
            margin-top: calc(100vw * (15 / 1300));
        }

        &:after {
            top: calc(100vw * (7 / 1300));

            width: calc(100vw * (4 / 1300));
            height: calc(100vw * (4 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};

        padding-left: ${M(10)};

        &:not(:last-child) {
            margin-top: ${M(10)};
        }

        &:after {
            top: ${M(7)};

            width: ${M(4)};
            height: ${M(4)};
        }
    }
`;

const PopWrap = styled.div`
    position: relative;

    display: flex;
    align-items: center;
`;
